import React, { useEffect, useState   } from 'react';
import '../../../../../App.css';
import MUIDataTable           from 'mui-datatables';
import {makeStyles          } from '@material-ui/core/styles';
import {Container} from '@material-ui/core';
import SearchBar              from '../../../../../components/shared/SearchBar';
import generateStyles         from './style';
import * as itemService       from  '../items.service';
import { Item } from '../items.model';
import { Link } from 'react-router-dom';
import { deleteItem } from '../items.service';
import Loading from '../../../../../components/shared/Loading';
import { useConfirm } from 'material-ui-confirm';

const options: any = {
  selectableRows: 'none',
   setRowProps: (_columns: any, _dataIndex: any, _rowIndex: any) => {
    return {
      style: {boxShadow: '0px 3px 5px #00000029', borderRadius: 6,}
    };
  }
};

export default function ItemList(_props: any): JSX.Element {
  const [rows, setRows] = useState<any[]>([]);
  const [itemList, setItemList] = useState<any[]>([]);
  const classes: any = generateStyles();
  let [loading, setLoading]   =   useState(false);
  const confirm = useConfirm();
  let mounted = true;


  const handleItemDelete = (id: string, index: number) => {
    confirm({
      title: 'Heads Up,',
      description: 'Are your sure? Want to delete this Item?',
      cancellationText: 'No',
      confirmationText: 'Yes, Delete it!',
      dialogProps: {
        open: true,
        maxWidth: 'xs'
      }
    })
    .then(() => {
      setLoading(true);
      deleteItem(id)
      .then((_: any) => {
        setLoading(false);
        let newRows = [...rows]
        newRows.splice(index, 1);
        setRows(newRows);
      })
      .catch((err: any) => {
        setLoading(false);
        console.log(err)
      });
    })
    .catch(() => console.log('Cancelled!'))
  }


  const columns: any = [
 
    {
      name:"sno",
      label: 'S.NO',
      options: {
        sort: false,
        setCellHeaderProps: (_value: any) => ({ style: { borderBottomLeftRadius: 6, borderTopLeftRadius: 6, display: 'flex', height: '52.8px', justifyContent: 'center', alignItems: 'center' } }),
        setCellProps: (_cellValue: any, _rowIndex: any, _columnIndex: any) => ({style: {borderBottomLeftRadius: 6, borderTopLeftRadius: 6}}),
        customBodyRender: (_value: any, tableMeta: any, _updateValue: any) => {
          console.log(rows)
          return (
            <div style={{textAlign: 'center', color:"#112B42"}}>
              {tableMeta.rowIndex + 1}
            </div>
          );
        }
      }
    },
    {
      name:"itemName",
      label: 'Item Name',
      options: {
        sortThirdClickReset: true,
        customBodyRender: (value: any, _tableMeta: any, _updateValue: any) => {
          return (
            <div style={{color:"#112B42"}}>
              {value}
            </div>
          );
        }
      }
    }, 
    {
      name: 'hsnCode',
      label:"HSN Code",
      options: {
        sort: false,
        customBodyRender: (value: any, _tableMeta: any, _updateValue: any) => {
          return (
            <div style={{color:"#112B42"}}>
              {value}
            </div>
          );
        }
      }
    },
    { 
      name: "itemType",
      label:"Item Type",
      options: {
        sortThirdClickReset: true,
        customBodyRender: (value: any, _tableMeta: any, _updateValue: any) => {
          return (
            <div style={{color:"#112B42"}}>
              {value}
            </div>
          );
        }
      }
    }, 
    {
      name: "sku",
      label:"SKU",
      options: {
        sort: false,
        customBodyRender: (value: any, _tableMeta: any, _updateValue: any) => {
          return (
            <div style={{color:"#112B42"}}>
              {value}
            </div>
          );
        }
      }
    },
    {
      name: "tax",
      label:"Tax",
      options: {
        sortThirdClickReset: true,
        customBodyRender: (value: any, _tableMeta: any, _updateValue: any) => {
          return (
            <div style={{color:"#112B42"}}>
              {value}
            </div>
          );
        }
      }
    },
    {
      name: "unit",
      label:"Unit",
      options: {
        sortThirdClickReset: true,
        customBodyRender: (value: any, _tableMeta: any, _updateValue: any) => {
          return (
            <div style={{color:"#112B42"}}>
              {value}
            </div>
          );
        }
      }
    }, 
    {
      name: "rate",
      label:"Rate",
      options: {
        sortThirdClickReset: true,
        setCellHeaderProps: (_value: any) => ({className: makeStyles({'rateHeader': {'& > span': {justifyContent: 'flex-end'}}})().rateHeader}),
        customBodyRender: (value: React.ReactNode, _tableMeta: any, _updateValue: any) => {
          return (
            <div className="txt-al-r" style={{color:"#112b42"}}>
              ₹ {value?.toLocaleString('en-IN')}
            </div>
          );
        }
      }
    },
    {
      name: 'action',
      label: "Action",
      options: {
        filter: false,
        sort: false,
        empty: true,
        setCellHeaderProps: (_value: any) => ({ style: { borderBottomRightRadius: 6, borderTopRightRadius: 6, display: 'table-cell', textAlign: 'right', paddingRight: 20 } }),
        setCellProps: (_cellValue: any, _rowIndex: any, _columnIndex: any) => ({style: {borderBottomRightRadius: 6, borderTopRightRadius: 6}}),
        customBodyRender: (value: any, tableMeta: any, _updateValue: any) => {
          return (
            <div className="txt-al-r">
              <Link to={`/dashboard/items/${value}`}><img alt="editicon" src="/img/editpencil.png"  style={{cursor: 'pointer', width:"17px", marginLeft:"13px"}}/></Link>
              <img alt="deleteicon" src="/img/delete.png" onClick={() => handleItemDelete(value, tableMeta.rowIndex)}  style={{cursor: 'pointer', width:"13px", marginLeft:"13px", marginRight:"10px"}}/>
            </div>
          );
        }
      }
    },
  ];


  const fetchAndSetItemList = async () => {
    setLoading(true);
    itemService.getAllItems((items: Item[]) => {
      const itemRows = items.map(mapItemToRow);
      console.log(itemRows);
      if(mounted) {
        setRows(itemRows);
        setItemList(itemRows);
        setLoading(false);
      }
    });
  }

  useEffect(()=>{
    fetchAndSetItemList();   
    return () => {
      mounted = false;
    }
  }, [])


  const mapItemToRow = (item: Item, _index: number) => {
    return {
      itemName: item.name,
      hsnCode: item.hsnCode,
      itemType: item.type,
      sku: item.sku,
      tax: item.tax,
      unit: item.unit,
      rate: item.rate,
      action: item.id
    }
  }


  const handleSearch = (text: string) => {
    const items = itemList.filter((item: any) => (item.itemName.toLowerCase().startsWith(text.toLowerCase().trim())))
    setRows(items);
  }

  
  return (
    <>
      <Container maxWidth="lg">
        <header className={classes.header}>
          <span style={{color:"#112B42"}}>Items List</span>
          <SearchBar searchText="Search Items..." addBtnLink='/dashboard/items/new' size="lg" searchFunction={handleSearch}/>
        </header>
      </Container>
      <hr style={{height: 1, backgroundColor: '#ccc', border: 'none'}}></hr>
      <Container maxWidth="lg" className="mt-20">       
          <MUIDataTable title={"ACME Employee list"} data={rows} columns={columns} options={options} />      
      </Container>
      <Loading loading={loading} text="Loading...."/>
    </>
  
  );
}
